'use strict';

var OnlineLogitCalibrationLegendDirective = function OnlineLogitCalibrationLegendDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/online-logit-calibration-legend.html'),
    controller: 'OnlineLogitCalibrationLegendController',
    scope: {
      selectedView: '='
    }
  };
};
OnlineLogitCalibrationLegendDirective.$inject = [];
module.exports = OnlineLogitCalibrationLegendDirective;